export function validateConformance(columns, contract) {
    const { fields, policy } = contract;
    const out = [];
    const colByName = new Map(columns.map(c => [c.name, c]));
    const schemaNames = new Set(fields.map(f => f.name));
    if (policy.requireRequiredFields) {
        for (const f of fields) {
            if (f.required && !colByName.has(f.name)) {
                out.push({ kind: "missing_required", field: f.name });
            }
        }
    }
    if (policy.enforceTypes) {
        for (const f of fields) {
            const col = colByName.get(f.name);
            if (col && (col.dataType ?? "raw") !== f.type) {
                out.push({ kind: "type_mismatch", field: f.name, detail: `expected ${f.type}` });
            }
        }
    }
    if (policy.enforceConstraints) {
        for (const f of fields) {
            // Constraint conformance is structural here: the column must exist; runtime value
            // checks are out of scope (spec §7). Flag only when a constrained field is absent.
            if (f.constraints && !colByName.has(f.name)) {
                out.push({ kind: "constraint_mismatch", field: f.name });
            }
        }
    }
    if (policy.closedSet) {
        for (const c of columns) {
            if (!schemaNames.has(c.name))
                out.push({ kind: "extra_column", field: c.name });
        }
    }
    if (policy.enforceOrder) {
        // Compare the relative order of the columns that ARE in the schema against the schema order.
        const present = columns.filter(c => schemaNames.has(c.name)).map(c => c.name);
        const expected = fields.filter(f => present.includes(f.name)).map(f => f.name);
        for (let i = 0; i < present.length; i++) {
            if (present[i] !== expected[i]) {
                const fieldName = present[i];
                out.push({ kind: "order_mismatch", field: fieldName });
                break;
            }
        }
    }
    return out;
}
//# sourceMappingURL=validate-conformance.js.map